import { createTheme } from '@material-ui/core/styles';
import styles from './StyleExports.scss';

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 0,
      md: parseInt(styles.tablet),
      lg: parseInt(styles.desktop),
      xl: parseInt(styles.desktopBig),
    },
  },
  palette: {
    primary: {
      main: styles.black,
      dark: styles.formBlue,
    },
    error: {
      main: styles.errorRed,
    },
    text: {
      primary: styles.black,
      secondary: styles.accessibleGray,
    },
  },
  typography: {
    fontSize: 16,
    fontFamily: 'Graphik, sans-serif',
  },
});
